export default "__VITE_ASSET__DoYRoIEs__"